import React from 'react';
import { CardGridStyles as S } from './CardGrid.styles';
const CardGrid = ({ children, cardsPerRow }) => {
    return React.createElement(S.Container, { "data-cards-per-row": cardsPerRow }, children);
};
export default CardGrid;
